import React from 'react';
import Charts from 'apps/hiring/components/charts';
import PropTypes from 'prop-types';
import EvaluateEmployeeList from 'apps/hiring/components/evaluate-employee-list';
import Loading from 'library/components/loading';
import { resolve } from 'library/helpers/path-resolver';
import {
  employeesGroupQuery,
  employeesGroupParseQuery,
} from 'apps/hiring/queries/groups/employeesGroupQuery';

import 'apps/hiring/styles/components/charts.scss';
import 'apps/hiring/styles/components/evaluate.scss';

class EmployeeCharts extends React.Component {
  static defaultProps = {
    allEmployees: {},
  };

  state = {
    selected: null,
    hoverSelected: null,
    loading: false,
    selectedEmployee: null,
  };

  setSelected = (id) => {
    this.setState({
      hoverSelected: id,
    });
  };

  clearSelected = () => {
    this.setState({
      hoverSelected: null,
    });
  };

  handle_employees = (emp) => {
    if (typeof emp == 'number')
      emp = resolve(this.props, 'users', []).find((lol) => lol.id == emp);

    this.setState({
      selectedEmployee:
        resolve(this.state, 'selectedEmployee/id', null) === emp.id
          ? null
          : emp,
      selected: resolve(this.state, 'selected', null) == emp.id ? null : emp.id,
    });
  };

  onChartSelect = (type, user_id) => {
    resolve(this, `handle_${type}`)(user_id);
  };

  render() {
    const {
      allEmployees,
      assessments,
      match,
      graph_data,
      graph_loading,
      reload_graph,
      users,
    } = this.props;

    const { selected, selectedEmployee } = this.state;

    if (graph_loading) {
      return (
        <div className="hiring-employee-evaulate-loading">
          <Loading />
        </div>
      );
    }

    if (users.length == 0) {
      return (
        <div style={{ height: 'auto' }} className="hiring-evaluate-cta">
          <h1>There are no completed assessments</h1>
        </div>
      );
    }

    return (
      <div className="hiring-section-body">
        <div className="hiring-section-sidebar">
          <EvaluateEmployeeList
            query={allEmployees.allEmployeesQuery || employeesGroupQuery}
            parseQuery={
              allEmployees.allEmployeesParseQuery || employeesGroupParseQuery
            }
            match={match}
            reload={reload_graph}
            noMatchScore
            noSort
            loading={graph_loading}
            onMouseOver={this.setSelected}
            onMouseLeave={this.clearSelected}
            onEmployeeSelect={this.handle_employees}
            tags={[
              ...users.map((e) => ({
                id: e.id,
                tag: (
                  <span className="hiring-evaluate-sidebar-item-tag-color-tertiary" />
                ),
              })),
              ...(selectedEmployee
                ? [
                    {
                      id: resolve(selectedEmployee, 'id', null),
                      tag: (
                        <span className="hiring-evaluate-sidebar-item-tag-color-auxilary-2" />
                      ),
                    },
                  ]
                : []),
            ]}
          />
        </div>
        <div className="hiring-section-content hiring-charts">
          <Charts
            noToggle
            assessments={assessments}
            selected={selected}
            onSelect={this.onChartSelect}
            hoverSelected={this.state.hoverSelected}
          />
        </div>
      </div>
    );
  }
}

EmployeeCharts.propTypes = {
  allEmployees: PropTypes.object,
  assessments: PropTypes.array,
  users: PropTypes.array,
  graph_loading: PropTypes.bool,
};

export default EmployeeCharts;
